import { render, staticRenderFns } from "./QTexto.vue?vue&type=template&id=10ee7882"
import script from "./QTexto.vue?vue&type=script&lang=js"
export * from "./QTexto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports